<template>
    <div class="topbar-container">
        <div class="scrollbar-container">
            <div class="line"></div>
            <validation-observer v-slot="{ invalid }" ref="form">
                <validation-provider
                    rules="required|digits:14"
                    v-slot="{ errors }"
                    name="卡号"
                    :customMessages="{required:'请输入卡号'}"
                >
                    <van-field
                        v-model="formData.cardNumber"
                        clearable
                        maxlength="14"
                        placeholder="请输入卡号"
                        class="border-bottom"
                    >
                        <div slot="left-icon" class="ico-card bg-contain"></div>
                        <zb-warning slot="right-icon" :message="errors[0]" />
                    </van-field>
                </validation-provider>
                <validation-provider
                    rules="required|alpha_num|min:8"
                    name="兑换码"
                    v-slot="{ errors }"
                    :customMessages="{required:'请输入兑换码'}"
                >
                    <van-field
                        v-model="formData.redemptionCode"
                        maxlength="12"
                        clearable
                        placeholder="请输入兑换码"
                    >
                        <div slot="left-icon" class="ico-card bg-contain"></div>
                        <zb-warning slot="right-icon" :message="errors[0]" />
                    </van-field>
                </validation-provider>
                <div class="bh bc footBar">
                    <van-button
                        :class="getBtnCls(invalid)"
                        @click="onSaveClick"
                        class="btn btn-goodbuy"
                    >
                        <span class="fz_30 btn-span">立即激活</span>
                    </van-button>
                </div>
            </validation-observer>
            <div class="description c_666 fz_28">
                <div>使用说明：</div>
                <div>1、输入卡片背面的卡号;</div>
                <div>2、刮开卡片背面的兑换码涂层并输入兑换码;</div>
                <div>3、点击立即激活进入车主卡页面;</div>
                <div>4、激活后请尽快兑换成车主币，自激活后有效期一年;</div>
                <div>
                    5、如遇到问题，请拨打客服电话:
                    <span class="c_warning">&nbsp;028-61521022&nbsp;</span>咨询。
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mixinValid } from "@/mixin/valid";
import { activationOwner } from "@/api/user";
export default {
    mixins: [mixinValid],
    name: "UserOwnerActivation",
    data() {
        return { formData: { cardNumber: "", redemptionCode: "" }};
    },
    methods: {
        onSaveClick() {
            const me = this;
            me.validForm().then(() => {
                activationOwner(me.formData).then(res => {
                    me.replaceGo("UserCouponsHome", {
                        active: 1
                    });
                });
            });
        }
    }
};
</script>

<style scoped lang="scss">
/deep/ .van-cell {
    padding: 50px 30px;
    .van-field__control {
        font-size: 34px;
    }
}
.topbar-container {
    background: #f1f2f3;
}
.btn-goodbuy {
    width: 510px;
    margin: 90px 0 58px 0;
}
.ico-card {
    width: 32px;
    height: 100%;
    margin-right: 10px;
}
/deep/.border-bottom {
    &:after {
        width: calc(100% - 60px);
        border-color: #dcdcdc !important;
        transform: scaleY(1);
    }
}
.description {
    padding: 0 51px;
    line-height: 1.8;
}
</style>

